// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1E0vp","item":"PaymentsMobile_item__27T8P","label":"PaymentsMobile_label__288Eb","amount":"PaymentsMobile_amount__ZTCxR"};